const groupWealthPageProductFields = (fields) => {
  const introFields = fields.filter((field) => field.key === 'title' || field.key === 'linkText');
  const productGroups = [];

  for (let index = 1; index <= 20; index += 1) {
    const groupFields = fields
      .filter((field) => field.key.startsWith(`product-${index}-`))
      .sort((a, b) => a.sortOrder - b.sortOrder);

    if (!groupFields.some((field) => field.key === `product-${index}-title`)) {
      break;
    }

    productGroups.push({ index, fields: groupFields });
  }

  return { introFields, productGroups };
};

export default groupWealthPageProductFields;
